<div class="select" [class.active]="hasFocus" *ngIf="options">
    <span class="labelcontent fixed" [innerHTML]="title"></span>
    <div class="select-wrapper" [class.disabled]="options.length <= 0">
        <select
            (focus)="hasFocus = true"
            (blur)="hasFocus = false"
            [disabled]="disable"
            #s="ngModel"
            (change)="onSelect(s.value)"
            [(ngModel)]="selectedValue"
        >
            <option *ngFor="let item of options" [value]="item.key">{{ item.value }}</option>
        </select>
    </div>
</div>
